export const Roles = {
  Codigo: null,
  Descripcion: null,
  Activo: true,
};

export const initialUsers = {
  Usuario: null,
  Nombre: null,
  Apellido: null,
  Password: null,
  RepetirPassword: null,
  Activo: true,
  Roles: [],
  PuestoUsuario: [],
  UsuariosRelacionados: [],
  Comision: 0,
  Email: null,
  TelefonoCelular: null,
  TelefonoLinea: null,
  Interno: null,
};

export const initial_filters = {
  Codigo: null,
  Usuario: null,
  Nombre: null,
  Apellido: null,
  Activo: true,
};
